import type {ProvisioningJob} from '@/lib/forex-api';
import OnboardingDiagnostic from './OnboardingDiagnostic';

const startupErrors:Record<string,string>={AUTO_PROCESS_LOST:'Terminal 启动后退出，EA 尚未完成连接',AUTO_START_TIMEOUT:'Terminal / EA 启动验证超时',AUTO_DESKTOP_UNAVAILABLE:'无法分配 Terminal 启动桌面',AUTO_TERMINAL_LAUNCH_FAILED:'Terminal 进程创建失败'};
export default function ProvisioningFailure({job,busy=false,onRetry,canOperate=false}:{job:ProvisioningJob;busy?:boolean;onRetry?:()=>void;canOperate?:boolean}) {
  if(job.status!=='failed')return null;
  return <div role="alert" className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm space-y-1">
    <p className="font-medium text-red-700">开通失败</p>
    <p>{startupErrors[job.last_error_code||''] || '实例开通未完成，请检查失败原因。'}</p>
    <OnboardingDiagnostic diagnostics={job.diagnostics}/>
    {job.last_error_code&&<p>错误：{job.last_error_code}</p>}
    {job.attempt!==undefined&&<p>已尝试 {job.attempt} 次</p>}
    {job.can_retry&&(!job.diagnostics||job.diagnostics.retryable)?canOperate&&onRetry&&<button disabled={busy||!job.revision} className="mt-2 rounded-lg border px-3 py-2 disabled:opacity-40" onClick={onRetry}>重试开通</button>:<p>当前任务不允许重试。请查看操作记录，核对凭据、节点及原实例状态；不会自动增加重试额度。</p>}
  </div>;
}

